// The ONE place the storefront's breakpoints live. app.css uses the same
// numbers (phone: max-width 767px; tablet: max-width 1023px; desktop from
// 768px up), so a component that branches in JS and a rule that branches in
// CSS flip at the same width. Before this, Header flipped at 767, Google
// Translate at 768, the checkout at 1024 and the CSS at 767 / 768 / 769
// depending on the block — an iPad in portrait (768px) got the desktop
// React tree under the phone CSS.
export const MOBILE_MAX_PX = 767;
export const TABLET_MAX_PX = 1023;

export const MOBILE_QUERY = `(max-width: ${MOBILE_MAX_PX}px)`;
export const TABLET_QUERY = `(max-width: ${TABLET_MAX_PX}px)`;

// A touch-first device: no hover and a coarse pointer. Phones and tablets
// match; a laptop with a touchscreen does not (it has a fine pointer too),
// which is the right call for hover-driven affordances.
export const TOUCH_QUERY = "(hover: none) and (pointer: coarse)";

export function mediaMatches(query) {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }
  return window.matchMedia(query).matches;
}

/** Phone-width viewport right now (one-shot read; use useIsMobile() in render). */
export const isMobileViewport = () => mediaMatches(MOBILE_QUERY);

/** Tablet-or-narrower viewport right now. */
export const isTabletViewport = () => mediaMatches(TABLET_QUERY);

/** Touch-first device (no hover, coarse pointer). */
export const isTouchDevice = () => mediaMatches(TOUCH_QUERY);
